module.exports = __webpack_public_path__ + "static/img/logo_app.eba01b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_app.png
// module id = 5Nhs
// module chunks = 0